import { max } from "lodash";
import { colors } from "./config";

export const Menu = {
  baseStyle: {
    groupTitle: {
      // For these styles we have to raise the specifity level to the max
      // It's due to the fact that the menu title is rendered in p tags
      color: '#06BCC1 !important',
      fontWeight: '700 !important',
      fontSize: '16px !important',
      mx: '0 !important',
      my: '0 !important',
      padding: '12px 12px 14px 18px !important',
      borderBottom: '1px solid #F0F0F0',
    },
    list:  {
      padding: 0,
      overflow: 'hidden',
      minWidth: 'auto',
      borderRadius: '8px',
    },
    item:  {
      padding: '14px 40px 14px 18px',
      color: colors.text.secondary,
      paddingTop: '8px',
      paddingBottom: '8px',
      ':not(:last-child)': {
        borderBottom: '1px solid #F0F0F0',
      },
      _hover: {
        bg: colors.brand.primary.opaque,
        color: colors.brand.primary.base,
        'svg': {
          color: 'brand.500',
          fill: 'brand.500',
        }
      },
      _focus: {
        bg: colors.brand.primary.opaque,
        color: colors.brand.primary.base,
      },
      _active: {
        bg: colors.brand.primary.opaque,
        color: colors.brand.primary.base,
      },
    }
  },
};
